import http from './http';
import config from '~/config';
import sectionTypes from '~/pages/PreliminaryTitleOpinion/sections/sectionTypes';
import { formattedDate } from '~/util/dateUtils';

const endpoint = `${config.urls.base}/titleOpinion`;
/**
 * 
 * @param {*} payload 
 * @returns 
 */

export const createPreliminary = async (payload) => {
    try {
        const response = await http.post(`${endpoint}`, payload);

        if (response.errored) {
            throw new Error(response.error);
        }

        return response;
    } catch (err) {
        console.error(err);
    }
};

export const getTitleOpinion = async (id) => {
    const response = await http.get(`${endpoint}/${id}`);

    if (response.errored) {
        console.error(`Error fetching titleOpinion: ${response.error}`);
        return null;
    }
    return response;
};

export const getTitleOpinionDetails = async (id) => {
    const response = await http.get(`${endpoint}/${id}/details`);

    if (response.errored) {
        console.error(`Error fetching titleOpinion: ${response.error}`);
        return null;
    }
    return response;
};

export const updateTitleOpinion = async (id, payload = {}) => {
    try {
        const uri = `${endpoint}/${id}/details`;

        const response = await http.put(uri, payload);

        if (response.errored) {
            throw new Error(response.error);
        }

        return response;
    } catch (err) {
        console.error(err);
    }
};

export const addAttachment = async (titleOpinionId, document = {}) => {
    const uri = `${endpoint}/${titleOpinionId}/attachments`;

    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension,
        description: document.description
    };

    return http.post(uri, upload);
};

export const getPreliminaryTitleOpinionDoc = async (titleOpinionId) => {
    const response = await http.get(`${endpoint}/${titleOpinionId}/print`);
    
    if (response.errored) {
        console.error(`Error fetching Preliminary title Opinion doc: ${response.error}`);
        return null;
    }
    return response;
};

export const getStraightFinalOpinionDoc = async (titleOpinionId) => {
    const url = `${config.urls.base}/straightFinal`;
    const response = await http.get(`${url}/${titleOpinionId}/print`);
    if (response.errored) {
        console.error(`Error fetching Preliminary title Opinion doc: ${response.error}`);
        return null;
    }
    return response;
};

export const submitPTORequest = async (titleOpinionId) => {
    const response = await http.get(`${endpoint}/${titleOpinionId}/details`);
    if (response.errored) {
        console.error(`Error at fetching Priority Title Opinion - ${response.error}`);
        return response;
    } else {
        // Create Order Request

        const propertyInfo = response.titleOpinionDetails.filter(x => x.sectionType == sectionTypes.PROPERTY_INFO)[0];
        const titleOpinionInfo = response.titleOpinionDetails.filter(x => x.sectionType == sectionTypes.TITLE_INSURANCE_APPLICATION)[0];
        const firmId = response.titleOpinion.firmId;
        const sellerData = propertyInfo ? propertyInfo.sectionDetails.filter(b => b.details.type === 'owner') ?? [] : [];
        const buyerData = titleOpinionInfo.sectionDetails ? titleOpinionInfo.sectionDetails.filter(b => b.details.type === 'insured') ?? [] : [];
        const lenderData = titleOpinionInfo ? titleOpinionInfo.sectionDetails.filter(b => b.details.type === 'lenderPrimary')[0] : null;
        const estimatedClosingDate = new Date(propertyInfo.sectionData.estimatedClosingDate);

        /*const tempBuyerType = titleOpinionInfo.sectionData.needOwnerCoverage === 'No' || titleOpinionInfo.sectionData.sameAsOwner ? 
            (sellerData.details.ownerSecondary == '' || (sellerData.details.ownerSecondary && Object.keys(sellerData.details.ownerSecondary).length == 0)  ? 'Single' : 'Joint') 
            : (buyerData.details.insuredSecondary == '' || (buyerData.details.insuredSecondary && Object.keys(buyerData.details.insuredSecondary).length == 0)  ? 'Single' : 'Joint');*/
        const tempBuyerType = "";

        const tempBuyer =
            titleOpinionInfo.sectionData.needOwnerCoverage === 'Yes' ?
                ((titleOpinionInfo.sectionData.sameAsOwner
                    && propertyInfo.sectionData.transactionType
                    && propertyInfo.sectionData.transactionType.label.toLowerCase() !== 'purchase') ?
                    sellerData.map((sellerData) => {
                        return {
                            FirstName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerFirstName : '',
                            MiddleName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerMiddleName : '',
                            LastName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerLastName : '',
                            Suffix: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerSuffix : '',
                            Vesting: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.relationship.value : '',
                            Type: sellerData.details.ownerPrimaryType.value,
                            OrgName: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityName : '',
                            OrgType: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityType.label : '',
                            BuyerType: titleOpinionInfo.sectionData.needOwnerCoverage === 'No' || titleOpinionInfo.sectionData.sameAsOwner ?
                                (sellerData.details.ownerSecondary == '' || (sellerData.details.ownerSecondary && Object.keys(sellerData.details.ownerSecondary).length == 0) ? 'Single' : 'Joint')
                                : (buyerData[0].details.insuredSecondary == '' || (buyerData[0].details.insuredSecondary && Object.keys(buyerData[0].details.insuredSecondary).length == 0) ? 'Single' : 'Joint'),
                            JointPerson: {
                                FirstName: sellerData.details.ownerSecondary.ownerFirstName,
                                MiddleName: sellerData.details.ownerSecondary.ownerMiddleName,
                                LastName: sellerData.details.ownerSecondary.ownerLastName,
                                Suffix: sellerData.details.ownerSecondary.ownerSuffix,
                            }
                        };
                    })
                    : buyerData.map((buyerData) => {
                        return {
                            FirstName: buyerData.details.insuredPrimaryType.value == 'Individual' ? buyerData.details.insuredPrimary.insuredFirstName : '',
                            MiddleName: buyerData.details.insuredPrimaryType.value == 'Individual' ? buyerData.details.insuredPrimary.insuredMiddleName : '',
                            LastName: buyerData.details.insuredPrimaryType.value == 'Individual' ? buyerData.details.insuredPrimary.insuredLastName : '',
                            Suffix: buyerData.details.insuredPrimaryType.value == 'Individual' ? buyerData.details.insuredPrimary.insuredSuffix : '',
                            Vesting: buyerData.details.insuredPrimaryType.value == 'Individual' ? buyerData.details.relationship.value : '',
                            Type: buyerData.details.insuredPrimaryType.value,
                            OrgName: buyerData.details.insuredPrimaryType.value == 'Entity' ? buyerData.details.insuredPrimary.insuredEntityName : '',
                            OrgType: buyerData.details.insuredPrimaryType.value == 'Entity' ? buyerData.details.insuredPrimary.insuredEntityType.label : '',
                            BuyerType: titleOpinionInfo.sectionData.needOwnerCoverage === 'No' || titleOpinionInfo.sectionData.sameAsOwner ?
                                (sellerData[0].details.ownerSecondary == '' || (sellerData[0].details.ownerSecondary && Object.keys(sellerData[0].details.ownerSecondary).length == 0) ? 'Single' : 'Joint')
                                : (buyerData.details.insuredSecondary == '' || (buyerData.details.insuredSecondary && Object.keys(buyerData.details.insuredSecondary).length == 0) ? 'Single' : 'Joint'),
                            JointPerson: {
                                FirstName: buyerData.details.insuredSecondary.insuredFirstName,
                                MiddleName: buyerData.details.insuredSecondary.insuredMiddleName,
                                LastName: buyerData.details.insuredSecondary.insuredLastName,
                                Suffix: buyerData.details.insuredSecondary.insuredSuffix,
                            }
                        };
                    }))
                : sellerData.map((sellerData) => {
                    return {
                        FirstName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerFirstName : '',
                        MiddleName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerMiddleName : '',
                        LastName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerLastName : '',
                        Suffix: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerSuffix : '',
                        Vesting: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.relationship.value : '',
                        Type: sellerData.details.ownerPrimaryType.value,
                        OrgName: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityName : '',
                        OrgType: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityType.label : '',
                        BuyerType: titleOpinionInfo.sectionData.needOwnerCoverage === 'No' || titleOpinionInfo.sectionData.sameAsOwner ?
                            (sellerData.details.ownerSecondary == '' || (sellerData.details.ownerSecondary && Object.keys(sellerData.details.ownerSecondary).length == 0) ? 'Single' : 'Joint')
                            : (buyerData[0].details.insuredSecondary == '' || (buyerData[0].details.insuredSecondary && Object.keys(buyerData[0].details.insuredSecondary).length == 0) ? 'Single' : 'Joint'),
                        JointPerson: {
                            FirstName: sellerData.details.ownerSecondary.ownerFirstName,
                            MiddleName: sellerData.details.ownerSecondary.ownerMiddleName,
                            LastName: sellerData.details.ownerSecondary.ownerLastName,
                            Suffix: sellerData.details.ownerSecondary.ownerSuffix,
                        }
                    };
                });

        const tempJointBuyer = titleOpinionInfo.sectionData.needOwnerCoverage === 'Yes' ?
            (titleOpinionInfo.sectionData.sameAsOwner ?
                sellerData.map((sellerData) => {
                    return {
                        FirstName: sellerData.details.ownerSecondary.ownerFirstName,
                        MiddleName: sellerData.details.ownerSecondary.ownerMiddleName,
                        LastName: sellerData.details.ownerSecondary.ownerLastName,
                        Suffix: sellerData.details.ownerSecondary.ownerSuffix,
                    };
                })
                : buyerData.map((buyerData) => {
                    return {
                        FirstName: buyerData.details.insuredSecondary.insuredFirstName,
                        MiddleName: buyerData.details.insuredSecondary.insuredMiddleName,
                        LastName: buyerData.details.insuredSecondary.insuredLastName,
                        Suffix: buyerData.details.insuredSecondary.insuredSuffix,
                    };
                })) :
            sellerData.map((sellerData) => {
                return {
                    FirstName: sellerData.details.ownerSecondary.ownerFirstName,
                    MiddleName: sellerData.details.ownerSecondary.ownerMiddleName,
                    LastName: sellerData.details.ownerSecondary.ownerLastName,
                    Suffix: sellerData.details.ownerSecondary.ownerSuffix,
                };
            });

        const tempSeller = sellerData.map((sellerData) => {
            return {
                FirstName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerFirstName : '',
                MiddleName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerMiddleName : '',
                LastName: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerLastName : '',
                Suffix: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.ownerPrimary.ownerSuffix : '',
                Vesting: sellerData.details.ownerPrimaryType.value == 'Individual' ? sellerData.details.relationship.value : '',
                Type: sellerData.details.ownerPrimaryType.value,
                OrgName: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityName : '',
                OrgType: sellerData.details.ownerPrimaryType.value == 'Entity' ? sellerData.details.ownerPrimary.ownerEntityType.label : '',
                SellerType: sellerData.details.ownerSecondary == '' || (sellerData.details.ownerSecondary && Object.keys(sellerData.details.ownerSecondary).length == 0) ? 'Single' : 'Joint',
                JointPerson: {
                    FirstName: sellerData.details.ownerSecondary.ownerFirstName,
                    MiddleName: sellerData.details.ownerSecondary.ownerMiddleName,
                    LastName: sellerData.details.ownerSecondary.ownerLastName,
                    Suffix: sellerData.details.ownerSecondary.ownerSuffix,
                }
            };
        });

        let _temp = ['DEFAULT'];

        //Check if state is South Carolina
        if (propertyInfo.sectionData.state && propertyInfo.sectionData.state.value === 'SC') {
            _temp = propertyInfo.sectionData.useOfProperty && propertyInfo.sectionData.useOfProperty.label == "Commercial" ? ["COMMERCIAL SC"] : ["RESIDENTIAL SC"];
        } else {
            _temp = propertyInfo.sectionData.useOfProperty && propertyInfo.sectionData.useOfProperty.label == "Commercial" ? ["COMMERCIAL"] : ["DEFAULT"];
        }

        let payload = {
            TitleOpinionId: titleOpinionId,
            SettlementType: "HUD",
            TransactionType: propertyInfo.sectionData.transactionType.label.toLowerCase(),
            PropertyAddress: {
                Street: propertyInfo.sectionData.street,
                City: propertyInfo.sectionData.city,
                Zip: propertyInfo.sectionData.zipcode,
                County: propertyInfo.sectionData.county,
                State: propertyInfo.sectionData.state ? propertyInfo.sectionData.state.value : 'NC'
            },
            BuyerType: tempBuyerType,
            Buyer: tempBuyer,
            JointBuyer: tempJointBuyer,
            SellerType: "", //passed in seller array object //sellerData.details.ownerSecondary == '' || (sellerData.details.ownerSecondary && Object.keys(sellerData.details.ownerSecondary).length == 0) ? 'Single' : 'Joint',
            Seller: tempSeller,
            JointSeller: [], //passed in tempSeller as property JointPerson
            Lender: {
                LookupCode: lenderData && lenderData.details.lenderDetailData.id ? lenderData.details.lenderDetailData.id : "",
                Name: lenderData && lenderData.details.lenderDetailData ? lenderData.details.lenderDetailData.lenderName : "",
                Street: lenderData && lenderData.details.lenderDetailData ? lenderData.details.lenderDetailData.lenderStreetAddress : "",
                City: lenderData && lenderData.details.lenderDetailData ? lenderData.details.lenderDetailData.lenderCity : "",
                State: lenderData && lenderData.details.lenderDetailData ? lenderData.details.lenderDetailData.lenderState : "",
                Zip: lenderData && lenderData.details.lenderDetailData ? lenderData.details.lenderDetailData.lenderZip : "",
            },
            LoanType: titleOpinionInfo?.sectionData?.loanTypePrimary?.label,
            LoanNumber: titleOpinionInfo?.sectionData?.loanNumberPrimary,
            SalesPrice: titleOpinionInfo?.sectionData?.ownerInsuranceCoverageAmount,
            PrincipalLoanAmount: titleOpinionInfo?.sectionData?.lenderInsuranceCoverageAmount,
            SettlementDate: formattedDate(estimatedClosingDate),
            SearchPeriodEndDate: formattedDate(estimatedClosingDate),
            SettlementAgent: firmId,
            isCashSale: propertyInfo.sectionData.cashSale ? propertyInfo.sectionData.cashSale : false,
            ProductType: propertyInfo.sectionData.useOfProperty ? propertyInfo.sectionData.useOfProperty.label : '',
            EscrowLegal: propertyInfo.sectionData?.notes,
            Template: _temp
        };

        const uri = `${endpoint}/createTitleOpinion`;
        http.post(uri, payload);
    }
};

export const getFinalTitleOpinionDocData = async (titleOpinionId) => {
    const response = await http.get(`${endpoint}/${titleOpinionId}/FTO`);

    if (response.errored) {
        console.error(`Error fetching Final title Opinion document data: ${response.error}`);
        return null;
    }
    return response;
};

export const submitFTO = async (titleOpinionId) => {
    const uri = `${endpoint}/${titleOpinionId}/final`;

    const response = await http.post(uri);

    if (response.errored) {
        console.error(`Unable to submit FTO - ${response.error}`);
        return response;
    }
    return response;
};

export const submitRevision = async (id, payload = {}) => {

    const uri = `${endpoint}/${id}/revision`;
    const response = await http.post(uri, payload);

    if (response.errored) {
        console.error(`Unable to submit PTO revision - ${response.error}`);
        return null;
    }
    return response;
};

export const verifyFileNumber = async (fileNumber) => {
    const uri = `${endpoint}/verify`;

    const response = await http.get2(uri, { fileNumber });

    if (response.errored) {
        console.error(`Unable to verify fileNumber '${fileNumber}' - ${response.error}`);
        return null;
    }

    return response;
};

export const list = async ({ offset = 0, size = 10, filters = {} } = {}) => {
    const params = {
        offset,
        size,
        ...filters
    };

    const response = await http.get2(endpoint, params);

    if (response.errored) {
        console.error(`Unable to fetch titleOpinions - ${response.error}`);
        return null;
    }

    return response;
};

export const listRevisions = async (titleOpinionId) => {
    const uri = `${endpoint}/${titleOpinionId}/revision`;

    const response = await http.get(uri);

    if (response.errored) {
        console.error(`${response.error}`);
        return null;
    }
    return response;
};

export const sendNewPreliminaryTitleOpinionEmail = async (titleOpinionId) => {
    const uri = `${endpoint}/sendNewPreliminaryTitleOpinionEmail/${titleOpinionId}`;

    const response = await http.get(uri);

    if (response.errored) {
        console.error(`${response.error}`);
        return null;
    }

    return response;

};

export const sendEmailOnSubmitFTO = async (titleOpinionId) => {
    const uri = `${endpoint}/FTO/sendemail/${titleOpinionId}`;

    const response = await http.get(uri);
    if (response.errored) {
        console.error(`${response.error}`);
        return null;
    }
    return response;

};

export const submitSTF = async (titleOpinionId) => {
    const uri = `${endpoint}/STF/submit/${titleOpinionId}`;

    const response = await http.get(uri);
    
    if (response.errored) {
        console.error(`${response.error}`);
        return null;
    }
    return response;
};

export const sendEmailOnSubmitSTF = async (titleOpinionId) => {
    const uri = `${endpoint}/STF/sendemail/${titleOpinionId}`;

    const response = await http.get(uri);

    if (response.errored) {
        console.error(`${response.error}`);
        return null;
    }
    return response;
};

export const duplicateTitleOpinion = async (payload) => {
    const uri = `${endpoint}/duplicate`;

    const response = await http.post(uri, payload);

    if (response.errored) {
        console.error(`Unable to duplicate title opinion - ${response.error}`);
        return response;
    }
    return response;
};

export const overlayTitleOpinion = async (payload) => {
    const uri = `${endpoint}/overlay`;

    const response = await http.post(uri, payload);

    if (response.errored) {
        console.error(`Unable to overlay title opinion - ${response.error}`);
        return response;
    }
    return response;
};

export default {
    createPreliminary,
    updateTitleOpinion,
    getTitleOpinion,
    getTitleOpinionDetails,
    verifyFileNumber,
    submitPTORequest,
    submitFTO,
    getPreliminaryTitleOpinionDoc,
    getFinalTitleOpinionDocData,
    submitRevision,
    list,
    sendNewPreliminaryTitleOpinionEmail,
    sendEmailOnSubmitFTO,
    submitSTF,
    getStraightFinalOpinionDoc,
    sendEmailOnSubmitSTF,
    duplicateTitleOpinion,
    overlayTitleOpinion
};